import styled, { css } from "styled-components";

export const WrapStyle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.typography.body1.regular.fontSize};

  cursor: pointer;

  ${({ theme }) => css`
    ${theme.media.small} {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.8rem;
    }
  `}
`;

export const IconStyle = styled.div<{ iconBgColor?: string }>`
  width: 4.8rem;
  height: 4.8rem;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ iconBgColor }) => iconBgColor && `background: ${iconBgColor};`}
  color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.typography.caption1.regular.fontSize};

  ${({ theme }) => css`
    ${theme.media.small} {
      width: 3.2rem;
      height: 3.2rem;

      border-radius: 0.8rem;

      svg {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
  `}
`;

export const ContentsBoxStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      gap: 0;
    }
  `}
`;

export const LabelStyle = styled.div`
  color: ${({ theme }) => theme.color.text.secondary};
  ${({ theme }) => theme.typography.body2.regular}

  ${({ theme }) => css`
    ${theme.media.small} {
      ${theme.typography.caption1.regular}
      letter-spacing: -0.036rem;
    }
  `}
`;

export const ValueStyle = styled.div`
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 3rem;
  letter-spacing: -0.06rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      ${theme.typography.body3.semibold}
    }
  `}
`;
